import * as d3 from 'd3';
// Sub-components
import TripRibbon from './TripRibbon';

const interpolateRainbowTruncated = (x) => d3.interpolateRainbow(1 - (1-x)*0.8);

const TripRibbons = ({ num_trips, trips, radius, highlighted_trip, highlighted_person, selected_person_change, initial_anim_delays, set_focused_trip, set_selected_trip }) => {

  const colors = d3.quantize(interpolateRainbowTruncated, num_trips);

  // Create ribbons
  let unhighlighted_ribbons = [];
  let highlighted_ribbons = [];
  for (let trip_index in trips) {
    trip_index = parseInt(trip_index);
    const trip = trips[trip_index];

    for (let i = 0; i < trip.person_trips.length; i++) {
      const start_j = (trip.person_trips.length === 1) ? i : i + 1;
      for (let j = start_j; j < trip.person_trips.length; j++) {
        // Create new ribbon
        let source = trip.person_trips[i];
        let target = trip.person_trips[j];
        // Ensure that source and target are ordered according to person_index, not
        // the order in which they appear in trip.person_trips array.
        if (source.person_index > target.person_index) {
          [source, target] = [target, source];
        }

        const focused = (source.person_index === highlighted_person) ||
                        (target.person_index === highlighted_person) ||
                        (trip_index === highlighted_trip);
        const ribbons = focused ? highlighted_ribbons : unhighlighted_ribbons;
        ribbons.push(<TripRibbon radius = {radius}
                                 key={`${source.person_index}_${target.person_index}_${trip_index}`}
                                 source={source}
                                 target={target}
                                 fill={colors[trip_index]}
                                 focused={focused}
                                 trip_index={trip_index}
                                 selected_person_change={selected_person_change}
                                 initial_anim_delay={initial_anim_delays[trip_index]}
                                 set_focused_trip={set_focused_trip}
                                 set_selected_trip={set_selected_trip}/>);

      }
    }
  }
  const ribbons = unhighlighted_ribbons.concat(highlighted_ribbons);

  return (
    <g>
      {ribbons}
    </g>
  );
};

export default TripRibbons;
